import React from "react";
import "./Quality.css"; // Assuming you have a CSS file for styling

const Quality = () => {
  return (
    <div>
         <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>
      
      <div class="course-container">
        <div class="header">
          <h1 class="title">Quality Assurance Courses</h1>
          <h2 class="info-title">Program Information</h2>
          <div class="program-info">
            <ul class="program-info-list">
              <li class="program-info-item">
                Short Term Programmes (0.5 day to 1 day)
              </li>
              <li class="program-info-item">
                Industry Case Studies and Videos included to enhance
                participants comprehension
              </li>
              <li class="program-info-item">
                Can be offered onsite if required
              </li>
            </ul>
          </div>
        </div>
        <div class="courses-grid">
          <div class="course-card">
            <h3 class="course-title">
              Applied FMEA [Failure Mode Effects and Analysis], Control Plans
            </h3>
            <p class="course-description">
              Systematic approach to identify potential failures in products and
              processes, including development of control plans
            </p>
            <span class="category-tag">Risk Management</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Applied SPC [Statistical Process Control]
            </h3>
            <p class="course-description">
              Statistical methods for monitoring and controlling manufacturing
              processes to ensure consistent quality
            </p>
            <span class="category-tag">Process Control</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Applied MSA [Measurement Systems Analysis]
            </h3>
            <p class="course-description">
              Evaluating the quality of measurement systems through statistical
              methods and analysis
            </p>
            <span class="category-tag">Measurement</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Change Management in the Semiconductor World
            </h3>
            <p class="course-description">
              Managing and implementing changes in semiconductor manufacturing
              while maintaining quality standards
            </p>
            <span class="category-tag">Management</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Quality Management System and Audits</h3>
            <p class="course-description">
              Understanding and implementing quality management systems and
              conducting effective audits
            </p>
            <span class="category-tag">Systems</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">8D Problem Solving</h3>
            <p class="course-description">
              Eight-discipline approach to identifying, correcting, and
              eliminating recurring problems
            </p>
            <span class="category-tag">Problem Solving</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">QC Tools</h3>
            <p class="course-description">
              Essential quality control tools and techniques for process
              improvement and monitoring
            </p>
            <span class="category-tag">Tools</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quality;
